

window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
//      http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', function ($locationProvider) {
  $locationProvider.hashPrefix('');
}]);
if (!window.prefetch) {
  angular.bootstrap(document.getElementById('angular_app_container'), ['app']);
  require('./app.js');
}


//////////////////
// WEBPACK FOOTER
// ./js/bootstrap.js
// module id = ./js/bootstrap.js
// module chunks = 0